import {LatLngTuple} from 'leaflet';

const swapLatLng = (coordinates: LatLngTuple): LatLngTuple => [coordinates[1], coordinates[0]];
export default swapLatLng;
